import {
  IOwnerVisitsData,
  IVisitsByProperty,
  IVisitsSection,
  VisitsPropertyFilter,
} from "../types/ownerDashboard.types";

export function getVisitsPropertyOptions(data: IOwnerVisitsData): IVisitsByProperty[] {
  const properties = new Map<number, IVisitsByProperty>();

  [...data.past_visits.by_property, ...data.upcoming_visits.by_property].forEach(
    (property) => {
      if (!properties.has(property.property_id)) {
        properties.set(property.property_id, property);
      }
    }
  );

  return Array.from(properties.values());
}

export function filterVisitsSection(
  section: IVisitsSection,
  propertyFilter: VisitsPropertyFilter
): IVisitsSection {
  if (propertyFilter === "all") {
    return section;
  }

  const byProperty = section.by_property.filter(
    (property) => property.property_id === propertyFilter
  );
  const items = section.items.filter(
    (visit) => visit.property_id === propertyFilter
  );
  const total = byProperty.reduce((sum, property) => sum + property.count, 0) || items.length;

  return {
    total,
    by_property: byProperty,
    items,
  };
}

export function filterVisitsByProperty(
  data: IOwnerVisitsData,
  propertyFilter: VisitsPropertyFilter
): IOwnerVisitsData {
  return {
    ...data,
    past_visits: filterVisitsSection(data.past_visits, propertyFilter),
    upcoming_visits: filterVisitsSection(data.upcoming_visits, propertyFilter),
  };
}
